import { RouteRecordRaw } from 'vue-router'

export const outcomesRoutes: RouteRecordRaw[] = [
  {
    path: '/desfechos',
    name: 'outcomes',
    component: () =>
      import(
        /* webpackChunkName: "outcomes" */
        '@/views/outcomes/HomePage.vue'
      ),
    meta: {
      title: 'Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/berlim',
    name: 'outcomes - Berlim',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-berlim" */
        '@/views/outcomes/BerlimForm.vue'
      ),
    meta: {
      title: 'Berlim - Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/igi',
    name: 'outcomes - IGI',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-igi" */
        '@/views/outcomes/IGIForm.vue'
      ),
    meta: {
      title: 'Indice de Gravidade da Insônia - Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/ndi',
    name: 'outcomes - NDI',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-ndi" */
        '@/views/outcomes/NDIForm.vue'
      ),
    meta: {
      title: 'NDI - Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/oswestry',
    name: 'outcomes - Oswestry',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-oswestry" */
        '@/views/outcomes/OswestryForm.vue'
      ),
    meta: {
      title: 'Oswestry - Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/eva',
    name: 'outcomes - Eva',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-eva" */
        '@/views/outcomes/EVAForm.vue'
      ),
    meta: {
      title: 'EVA - Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/startback',
    name: 'outcomes - StartBack',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-startback" */
        '@/views/outcomes/StartBackForm.vue'
      ),
    meta: {
      title: 'StartBack - Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/gad',
    name: 'outcomes - GAD',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-gad" */
        '@/views/outcomes/GADForm.vue'
      ),
    meta: {
      title: 'GAD - Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/phq',
    name: 'outcomes - PHQ',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-phq" */
        '@/views/outcomes/PHQForm.vue'
      ),
    meta: {
      title: 'PHQ - Calculadoras Alice',
      onlyLoggedIn: true
    }
  },
  {
    path: '/desfechos/centor',
    name: 'outcomes - Centor Score',
    component: () =>
      import(
        /* webpackChunkName: "outcomes-centor-score" */
        '@/views/outcomes/CentorScoreForm.vue'
      ),
    meta: {
      title: 'Centor Score - Calculadoras Alice',
      onlyLoggedIn: true
    }
  }
]
